export default "__VITE_ASSET__C1iXu57N__"